const getElementLineHeight = (element: HTMLElement) => {
  let temp = document.createElement(element.nodeName);
  temp.setAttribute(
    'style',
    `margin:0;padding:0;` +
      `font-family:${element.style.fontFamily};` +
      `font-size:${element.style.fontSize}`
  );
  temp.innerHTML = 'test';
  temp = element.parentNode.appendChild(temp);
  let ret = temp.clientHeight;
  temp.parentNode.removeChild(temp);
  return ret;
};

export default getElementLineHeight;
